import { css } from 'linaria';

export const buttonStyle = css`
  position: absolute;
  top: 50%;

  z-index: 2;
  margin-right: 0;
  --button-bg: var(--background-primary);
  --translate-distance: 0 !important;
  span {
    position: absolute;
  }
  &.left {
    left: 0;
    transform: translateY(-50%) translateX(-50%);
    span {
      left: -1px;
    }
  }
  &.right {
    right: 0;
    transform: translateY(-50%) translateX(50%);
    span {
      right: -1px;
    }
  }
`;
